export const ATUALIZAR_FILTROS = '@filtrosActions/ATUALIZAR_FILTROS'
export const DESCARTAR_FILTROS = '@filtrosActions/DESCARTAR_FILTROS'
export const DESCARTAR_FILTROS_SELECIONADOS_MENU_FILTROS =
  '@filtrosActions/DESCARTAR_FILTROS_SELECIONADOS_MENU_FILTROS'

export const atualizarFiltros = (filtros) => {
  return {
    type: ATUALIZAR_FILTROS,
    payload: filtros
  }
}

export const descartarFiltros = (filtrosKeys) => {
  return {
    type: DESCARTAR_FILTROS,
    payload: filtrosKeys
  }
}

export const descartarFiltrosSelecionadosMenuFiltros = () => {
  return {
    type: DESCARTAR_FILTROS_SELECIONADOS_MENU_FILTROS
  }
}
